import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpClient } from "@coworker/http-client";

type Data = {
  uid: string;
  countryId: string;
  storeId: string;
  teamId: string;
};

async function updateUser(uid: string, data: Data) {
  return await httpClient.core.put(`/users/${uid}`, {
    body: {
      uid,
      countryId: data.countryId,
      storeId: data.storeId,
      teamId: data.teamId,
    },
  });
}

export const useUpdateUser = (uid: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: Data) => updateUser(uid, data),
    onSuccess: async () => {
      queryClient.invalidateQueries({
        queryKey: ["user", uid],
      });
      await sessionStorage.clear();
      await localStorage.clear();
      window.location.assign("/home");
    },
  });
};
